<template>
  <div class="sidebar sidebar-fixed lh-lg" id="sidebar">
    <logo class="sidebar-brand position-relative" />
    <!-- @menu-clickイベントを監視してクリック処理をhandleMenuClickで行う -->
    <menu-list :menus="menus" @menu-click="handleMenuClick" />
  </div>
</template>

<script>
import Logo from "@/views/atoms/Logo";
import MenuList from "@/views/molecules/MenuList";
import { mapState, mapMutations } from "vuex";

export default {
  name: "BrokerSideMenu",
  components: {
    Logo,
    MenuList
  },
  data() {
    return {
      menuList: [
        { routeName: 'Top', displayName: 'TOP', icon: 'home', group: 'Home' },
        { routeName: 'AccountViewer', displayName: 'アカウント', icon: 'account', group: 'Account' },
        { routeName: 'BrokerageCompanyViewer', displayName: '会社情報', icon: 'company', group: 'Company' },
        { routeName: 'IssuanceRequestRegister', displayName: '発行依頼', icon: 'pencil', group: 'IssuanceRequest' },
        { routeName: 'IssuanceRequestOwnList', displayName: '発行依頼履歴', icon: 'folder', group: 'IssuanceHistory' },
        { routeName: 'OperationLogList', displayName: '操作ログ', icon: 'operation-log', group: 'OperationLog', isAdminOnly: true },
      ]
    };
  },
  computed: {
    ...mapState('account', {
      isSuperVisor: state => state.is_supervisor,
    }),
    menus() {
      if (this.isSuperVisor) {
        return this.menuList;
      } else {
        return this.menuList.filter(menudata => !menudata.isAdminOnly);
      }
    },
  },
  methods: {
    ...mapMutations('issuance_request_form', ['resetData']), // resetDataメソッドをVuexからインポート

    handleMenuClick(routeName) {
      // クリックされたメニューが「発行依頼」の場合にresetDataを実行
      if (routeName === 'IssuanceRequestRegister') {
        // 発行依頼画面表示中の場合はリセットしない
        if (this.$route.name === routeName) {
          return;
        }
        this.resetData();
      }
      // クリックしたルートに遷移
      this.$router.push({ name: routeName });
    }
  }
};
</script>
